import { arrayIncludesCount } from "./arrayIncludesCount";
export const arrayIncludesArray = (array, includesArray) => {
    return arrayIncludesCount(array, includesArray) === includesArray.length;
};
